import { List, Icon } from "components";
import { Button } from "ui/components/button";
import React from "react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import { DateTimeCell } from "components/cell/date/cell";
import HeaderPortal from "components/portal/header-portal";
import { PermissionControlledInput } from "permissions/components/input";
import { getdirectusUserFields } from "components/user/config";
import { EmployeeCell } from "components/cell/employee/cell";
import CreateItemButton from "components/buttons/create";
import { MENU } from "icons/src";
import { useNavigate } from "react-router-dom";
import { useDeleteMeeting } from "./crud/delete/mutation";
import { eventBus } from "utils/eventBus";

export default function Meetings() {
    const navigate = useNavigate();

    const deleteMeetingMutation = useDeleteMeeting({
        onSuccess: () => {
            eventBus.emit("refresh:list", "calendar_eventsmeetings-list");
        },
    });

    const fields = [
        "id",
        "title",
        "starts_at",
        "ends_at",
        getdirectusUserFields("user_created"),
    ];

    const columns = [
        {
            id: "title",
            header: "Title",
            accessorKey: "title",
            cell: ({ row }) => {
                const title = row.original.title;
                return (
                    <div className="w-100">
                        {title}
                    </div>
                );
            }
        },
        {
            id: "starts_at",
            header: "Start",
            accessorKey: "starts_at",
            sortable: true,
            cell: DateTimeCell,
        },
        {
            id: "ends_at",
            header: "End",
            accessorKey: "ends_at",
            sortable: true,
            cell: DateTimeCell,
        },
        {
            id: "user_created",
            header: "Created By",
            accessorKey: "user_created",
            cell: EmployeeCell,
        },
        {
            id: "actions",
            header: "",
            accessorKey: "id",
            cell: ({ row }) => {
                const id = row.original.id;

                return (
                    <div className="flex items-center gap-2 justify-end opacity-0 group-hover:opacity-100 transition">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button size="icon" variant="outline">
                                    <Icon icon={MENU} className="size-4" />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                                <PermissionControlledInput
                                    rule="update:*"
                                    collection="calendar_events"
                                >
                                    <DropdownMenuItem
                                        onClick={() => navigate(`${id}`)}
                                    >
                                        Edit
                                    </DropdownMenuItem>
                                </PermissionControlledInput>
                                <PermissionControlledInput
                                    rule="delete:*"
                                    collection="calendar_events"
                                >
                                    <DropdownMenuItem
                                        onClick={() => deleteMeetingMutation.mutateAsync({ meetingId: id })}
                                        disabled={deleteMeetingMutation.isPending}
                                    >
                                        Delete
                                    </DropdownMenuItem>
                                </PermissionControlledInput>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                );
            },
            sortable: false,
            meta: { align: "right" },
        },
    ];

    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="calendar_events"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Meeting</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <List
                title="Meetings"
                storageKey="meetings-list"
                endPoint="calendar_events"
                columns={columns}
                meta={{ fields }}
                sortBy="date_created"
            />
        </div>
    );
}
